import { TrackEventInput } from '@updater/ui-tracker';
import {
  Box,
  ButtonLink,
  Card,
  Text,
  TextLink,
  useTheme,
} from '@updater/ui-uds';
import { PageTemplate } from 'components/page-template';
import Link from 'next/link';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { useTracking } from 'react-tracking';
import { DOMAIN } from '../constants/analytics-tracker';
import { Subtitle } from './Subtitle';

interface Props {
  onDone?: () => Promise<void>;
}

export function TypeTwoFYMScreen({ onDone }: Props) {
  const theme = useTheme();

  const { trackEvent } = useTracking<TrackEventInput<unknown>>({
    domain: DOMAIN.FORWARD_MAIL,
  });

  return (
    <PageTemplate
      title="Forward your mail"
      subtitle={<Subtitle showStatusByDefault />}
    >
      <Box marginTop="l">
        {/* NOTE: DO we track this? */}
        <Card width="100%">
          <Box paddingY="l">
            <Text as="h3" variant="mBold">
              USPS Mail Forwarding
            </Text>
            <TextLink
              noVisitedColorChange
              target="__blank"
              href="https://moversguide.usps.com/mgo/disclaimer"
              marginTop="xs"
              variant="m"
              onClick={() =>
                trackEvent({
                  object: 'USPSAdditionalMailForwarding',
                  verb: 'clicked',
                })
              }
            >
              Visit website{' '}
              <Box display="inline-block">
                <ArrowSquareOut size={14} color={theme.colors.link} />
              </Box>
            </TextLink>
          </Box>
        </Card>
        <Link passHref href="/">
          <ButtonLink
            onClick={() => {
              trackEvent({
                object: 'non-invite-user-back-to-essentials',
                verb: 'clicked',
              });
              if (onDone) onDone();
            }}
            marginTop="l"
            isFluidWidth
          >
            All set!
          </ButtonLink>
        </Link>
      </Box>
    </PageTemplate>
  );
}
